// TUAS - Per-size shipping labels + delivery-info inside the size dropdown
// 1) Reads the per-size map injected by theme.liquid (<script data-ship-labels>)
//    and writes a shipping line on each size row inside the dropdown popover.
// 2) Takes the native "modal" block (DIFFERENT DELIVERY DATES? HERE'S WHY) and
//    surfaces its trigger INSIDE the size dropdown popover, under the sizes
//    (Alohas-style). The original page-flow link is removed; the modal dialog
//    itself is reused untouched. Spacing/styling live in custom-tuas.css.
// Self-contained: no dependency on any other custom file.
(function () {
  var STYLE_ID = 'tuas-ship-style';
  var modalReady = false;
  var deliveryTrigger = null;
  var deliveryLabel = '';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      'x-popover[id^="popover-variant-dropdown"] .popover__value-option{display:flex;align-items:center;}' +
      'x-popover[id^="popover-variant-dropdown"] .tuas-ship-label{margin-left:auto;padding-left:1rem;font-size:0.75rem;' +
      'letter-spacing:0.02em;color:#8a857c;white-space:nowrap;}';
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function readMap() {
    var el = document.querySelector('script[data-ship-labels]');
    if (!el) return {};
    try {
      var raw = JSON.parse((el.textContent || '').trim());
      var map = {};
      Object.keys(raw).forEach(function (k) {
        map[String(k).trim()] = raw[k];
      });
      return map;
    } catch (e) {
      return {};
    }
  }

  function sizeOf(option) {
    var spans = Array.prototype.slice.call(option.querySelectorAll('span'));
    var span = spans.find(function (s) {
      return !s.classList.contains('tuas-ship-label') && s.textContent.trim() !== '';
    });
    return ((span && span.textContent) || option.textContent || '').trim();
  }

  function apply() {
    var map = readMap();
    if (!Object.keys(map).length) return;

    var options = document.querySelectorAll('x-popover[id^="popover-variant-dropdown"] .popover__value-list .popover__value-option');
    if (!options.length) return;

    options.forEach(function (option) {
      var size = sizeOf(option);
      if (!size) return;

      var desired = map[size];
      if (!desired) return;

      var span = option.querySelector('.tuas-ship-label');
      if (!span) {
        span = document.createElement('span');
        span.className = 'tuas-ship-label';
        option.appendChild(span);
      }
      if (span.innerHTML !== desired) {
  span.innerHTML = desired;
}
    });
  }

  // Find the native modal trigger (by its button title), move the dialog to
  // <body> so it is independent of the hidden block, and hide the page-flow link.
  function prepareDeliveryModal() {
    if (modalReady) return;
    var block = document.querySelector('.product-info__block-item[data-block-type="modal"]');
    if (!block) return;

    var candidates = block.querySelectorAll('button, a');
    for (var i = 0; i < candidates.length; i++) {
      if ((candidates[i].textContent || '').toUpperCase().indexOf('DELIVERY DATES') > -1) {
        deliveryTrigger = candidates[i];
        break;
      }
    }
    if (!deliveryTrigger) return;

    deliveryLabel = deliveryTrigger.textContent.trim();

    var modalId = deliveryTrigger.getAttribute('aria-controls');
    var modalEl = modalId ? document.getElementById(modalId) : null;
    if (modalEl && modalEl.parentNode !== document.body) {
      document.body.appendChild(modalEl);
    }

    block.style.display = 'none';
    modalReady = true;
  }

  // Insert the delivery link inside each size dropdown popover, under the sizes.
  function injectInsidePopover() {
    if (!deliveryTrigger) return;
    var lists = document.querySelectorAll('x-popover[id^="popover-variant-dropdown"] .popover__value-list');
    lists.forEach(function (list) {
      var pop = list.closest('x-popover');
      if (!pop || pop.querySelector('.tuas-popover-info')) return;

      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'tuas-popover-info';
      link.textContent = deliveryLabel || 'DIFFERENT DELIVERY DATES? HERE\u2019S WHY';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var toggle = pop.id ? document.querySelector('.select[aria-controls="' + pop.id + '"]') : null;
        if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
          toggle.click(); // close the dropdown first
        }
        setTimeout(function () {
          if (deliveryTrigger) deliveryTrigger.click(); // open the modal
        }, 60);
      });
      list.insertAdjacentElement('afterend', link);
    });
  }

  function refresh() {
    prepareDeliveryModal();
    injectInsidePopover();
    apply();
  }

  function init() {
    injectStyles();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Maestrooo re-renders the variant picker on variant change - re-inject the
  // link and keep the per-size labels in sync.
  var mo = new MutationObserver(function () { refresh(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();

// ============================================================
// TUAS - No pre-selected size + "Select size" validation.
//   - The size field reads "Select size" until the customer
//     actively chooses (the engine keeps a variant under the
//     hood so price stays correct and the button stays enabled).
//   - "Chosen" is tracked via the size radios that belong to the
//     MAIN product FORM, NOT via DOM position. On mobile the
//     dropdown opens as a drawer that the theme moves out of the
//     picker, so position-based checks failed there; form-based
//     checks work on mobile and desktop alike.
//   - Add to cart is gated on the FORM submit, covering the main
//     button AND the sticky bar (both submit the same form).
//   - The dynamic "Buy it now" button is hidden until a size is
//     chosen (it bypasses submit, so it must be hidden).
//   - Invalid add: open the dropdown, outline it Winery red,
//     scroll it into view. CSS is injected here so this stays
//     self-contained and does not touch custom-tuas.css.
// ============================================================
(function () {
  var STYLE_ID = 'tuas-size-style';
  var SELECT_TEXT = 'Select size';
  var interacted = false;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      ".tuas-size-error .select{box-shadow:0 0 0 1.5px #6B2027 !important;border-color:#6B2027 !important;}" +
      ".tuas-size-error .select > span[id$='-selected-value']{color:#6B2027 !important;}" +
      "product-form.tuas-needs-size .shopify-payment-button{display:none !important;}";
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function mainPicker() {
    return document.querySelector('variant-picker[update-url]');
  }
  function mainFormId() {
    var mp = mainPicker();
    return mp ? mp.getAttribute('form-id') : null;
  }
  function triggers() {
    var mp = mainPicker();
    return mp ? mp.querySelectorAll('.select[aria-controls^="popover-variant-dropdown"]') : [];
  }
  function hasSizePicker() {
    return triggers().length > 0;
  }
  // Size radios that belong to the MAIN product form. Works even when the
  // popover/drawer is moved out of the picker on mobile.
  function sizeRadios() {
    var fid = mainFormId();
    if (!fid) return [];
    var all = document.querySelectorAll('input[type="radio"][data-option-position]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('form') === fid) out.push(all[i]);
    }
    return out;
  }
  function allChosen() {
    var radios = sizeRadios();
    if (!radios.length) return true;
    var byName = {};
    for (var i = 0; i < radios.length; i++) {
      var n = radios[i].name;
      if (!(n in byName)) byName[n] = false;
      if (radios[i].checked) byName[n] = true;
    }
    for (var k in byName) { if (byName.hasOwnProperty(k) && !byName[k]) return false; }
    return true;
  }
  function chosen() {
    return interacted && allChosen();
  }
  function sizeTextOf(opt) {
    var sp = opt.querySelector("span:not(.tuas-ship-label)");
    return ((sp && sp.textContent) || '').trim();
  }
  function setTriggerLabel(popId, text) {
    var span = document.getElementById(popId + '-selected-value');
    if (span && span.textContent.trim() !== text) span.textContent = text;
  }
  function setPlaceholders() {
    if (chosen()) return;
    var t = triggers();
    for (var i = 0; i < t.length; i++) {
      var span = t[i].querySelector("span[id$='-selected-value']");
      if (span && span.textContent.trim() !== SELECT_TEXT) span.textContent = SELECT_TEXT;
    }
  }
  function clearError() {
    var els = document.querySelectorAll('.tuas-size-error');
    for (var i = 0; i < els.length; i++) els[i].classList.remove('tuas-size-error');
  }
  function showError() {
    var btn = triggers()[0];
    if (!btn) return;
    var wrap = btn.closest('.relative') || btn.parentNode;
    if (wrap) wrap.classList.add('tuas-size-error');
    setPlaceholders();
    try { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    if (btn.getAttribute('aria-expanded') !== 'true') btn.click();
  }
  function syncPay() {
    if (!hasSizePicker()) return;
    var need = !chosen();
    var forms = document.querySelectorAll('product-form');
    for (var i = 0; i < forms.length; i++) forms[i].classList.toggle('tuas-needs-size', need);
  }
  // Register a real user choice. Scoped to the MAIN product form, so it works
  // on mobile even when the popover/drawer is moved out of the picker.
  function pick(opt) {
    if (!opt) return;
    var radio = opt.querySelector('input[type="radio"][data-option-position]');
    var fid = mainFormId();
    if (!radio || !fid || radio.getAttribute('form') !== fid) return;
    interacted = true;
    var pop = opt.closest('x-popover');
    if (pop && pop.id) setTriggerLabel(pop.id, sizeTextOf(opt));
    clearError();
    syncPay();
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.popover__value-list .popover__value-option');
    if (opt) pick(opt);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var opt = t.closest && t.closest('.popover__value-option');
    if (opt) pick(opt);
  }, true);

  // Gate add to cart (main + sticky share this form).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.closest('product-form')) return;
    if (!hasSizePicker()) return;
    if (chosen()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showError();
  }, true);

  function tick() {
    injectStyles();
    if (!hasSizePicker()) return;
    setPlaceholders();
    syncPay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
  var mo2 = new MutationObserver(function () { tick(); });
  mo2.observe(document.documentElement, { childList: true, subtree: true });
})();
